export const WEBSOCKET_TYPE_CUSTOM_FORM = 'fp_custom_form' as const;

export enum CustomFormWebsocketMessageAction {
  PDF_GENERATE_AND_SAVE_FINISH = 'pdf_generate_and_save_finish',
  PDF_GENERATE_AND_SAVE_ERROR = 'pdf_generate_and_save_error',
  REPORT_SEND_FINISH = 'report_send_finish',
  REPORT_SEND_ERROR = 'report_send_error',
}